import { createApiClient } from "../services/ApiClient";
import * as types from "./ActionTypes";
import { getCountries, getForms, getSettings } from "./index";
import { getMentorProcessAll, getMMProcessAll, getSlaveMentorsAll } from "./mentor";

export function auth() {
	return (dispatch: any) => {
		const api = createApiClient();
		dispatch({ type: types.LOADING_START, payload: "auth" });
		api.me({
			success: (data) => {
				if (data.isAuth && data.isAccess) {
					dispatch({ type: types.AUTH_USER_SUCCESS, payload: data });
					dispatch({ type: types.LOADING_FINISH, payload: "auth" });
					dispatch(getSettings());
					dispatch(getForms());
					dispatch(getCompanies());
					dispatch(getCountries());
					if (data.is_master_mentor) {
						dispatch(getMMProcessAll());
						dispatch(getSlaveMentorsAll());
					} else if (data.is_mentor) {
						dispatch(getMentorProcessAll());
					} else if (window.location.pathname === "/fasttrack/mentor/") {
						window.location.href = "/";
					}
				} else if (!data.isAuth && data.isAccess) api.redirect(window.location.href);
				else if (data.isAuth && !data.isAccess) api.singout(window.location.href);
				else if (window.top !== window.self) window.top.location.href = "/#/not-authorized";
				else window.location.href = "/#/not-authorized";
			},
		});
	};
}

export function getCompanies() {
	return (dispatch: any) => {
		const api = createApiClient();
		dispatch({ type: types.LOADING_START, payload: "companies" });
		api.getCompanies({
			success: (response) => {
				dispatch({ type: types.FETCH_COMPANIES, payload: response });
			},
			anyway: () => {
				dispatch({ type: types.LOADING_FINISH, payload: "companies" });
			},
		});
	};
}
